import ArticleBodySection from '../sections/ArticleBodySection'
import MasterpieceSection from '../sections/MasterpieceSection'
import SuggestedArticlesSection from '../sections/SuggestedArticlesSection'
import EditorialSignupSection from '../sections/EditorialSignupSection'

// Article data interface
export interface ArticleData {
  id: string
  slug: string
  category: string
  title: string
  banner_image: string
  content_intro?: string
  content1?: string
  content2?: string
  content3?: string
  content4?: string
  publish_date: string
  location: string
  desc?: string
  image1?: string
  image2?: string
  image3?: string
  image4?: string
  image5?: string
  image6?: string
  image7?: string
  image8?: string
}

interface ArticleDetailTemplateProps {
  article: ArticleData
}

export default function ArticleDetailTemplate({ article }: ArticleDetailTemplateProps) {
  return (
    <>
      {/* Hero Section - Same layout as ServicePageTemplate */}
      <section
        style={{
          minHeight: '560px',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
          width: '100%',
        }}
      >
        {/* Image Column */}
        <div
          style={{
            minHeight: '400px'
          }}
        >
          <img
            src={article.banner_image}
            alt={article.title}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        </div>

        {/* Content Column */}
        <div
          style={{
            backgroundColor: '#EFEFEF',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '64px 32px',
            minHeight: '400px'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '16px',
              textAlign: 'center'
            }}
          >
            {/* Category Label */}
            <h2
              style={{
                fontFamily: 'Cardo, serif',
                fontSize: '24px',
                fontStyle: 'italic',
                color: '#764F2B',
                margin: 0,
                lineHeight: 1.2
              }}
            >
              {article.category}
            </h2>

            {/* Main Title */}
            <h1
              style={{
                fontFamily: 'Cardo, serif',
                fontSize: 'clamp(32px, 8vw, 24px)',
                fontWeight: 'normal',
                color: '#000000',
                margin: 0,
                lineHeight: 1.1,
                letterSpacing: '-0.02em',
                wordBreak: 'break-word',
                hyphens: 'auto',
                maxWidth: '600px'
              }}
            >
              {article.title}
            </h1>

            {/* Small Content Labels */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '16px', alignItems: 'center' }}>
              <span
                style={{
                  fontFamily: 'Plus Jakarta Sans',
                  fontSize: '14px',
                  color: '#000000',
                  fontWeight: '500'
                }}
              >
                {new Date(article.publish_date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </span>
              <span
                style={{
                  fontFamily: 'Plus Jakarta Sans',
                  fontSize: '14px',
                  color: '#7B7B7B'
                }}
              >
                {article.location}
              </span>
            </div>
          </div>
        </div>
      </section>
      
      {/* Body Content Section */}
      <ArticleBodySection
        article={article}
      />
      
      {/* Masterpiece Section */}
      <MasterpieceSection />
      
      {/* Suggested Articles Section */}
      <SuggestedArticlesSection />
      
      {/* Editorial Signup Section */}
      <EditorialSignupSection />
    </>
  )
}